module.exports = __webpack_public_path__ + "static/media/icn_nn4m_white.2a5f4d40.svg";